module.exports = __webpack_public_path__ + "img/VinoTintoFT34Malbec.96a18d84.jpg";